var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      false
        ? _c(
            "div",
            [
              _c("j-assignment-form-update", {
                ref: "employeeForm",
                attrs: { mode: "update" },
                on: { data: _vm.getData }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [
          _c("b-col", { attrs: { sm: "12", md: "9" } }, [
            _c(
              "div",
              { staticClass: "float-right m__t--20" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn red",
                    on: {
                      click: function($event) {
                        _vm.openModalConfirm("delete")
                      }
                    }
                  },
                  [_vm._v("Delete")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn blue",
                    on: {
                      click: function($event) {
                        _vm.openModalConfirm("employment")
                      }
                    }
                  },
                  [_vm._v("Update")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12", md: "3" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "9" } },
            [
              _c("j-title-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { options: _vm.titlePosition }
              }),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: { "error-input": _vm.$v.data_position.position.$error }
                },
                [
                  _c("label", [_vm._v(" Position ")]),
                  _vm._v(" "),
                  _vm.defaultOptions.length > 0
                    ? _c("j-single-select", {
                        attrs: {
                          "is-async": true,
                          "cache-option": false,
                          "load-options": _vm.loadOptionsPosition,
                          "default-options": _vm.defaultOptions,
                          placeholder: "Ex: CTO",
                          "value-format": "object",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_position.position.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_position.position,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_position.position.$model"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue",
                  on: {
                    click: function($event) {
                      _vm.openModalConfirm("position")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.labelBtnPosition) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12", md: "3" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalConfirm",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("j-title-header", { attrs: { options: _vm.title } }),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.isOpen
                ? _c("j-modal-confirm-with-reason", {
                    attrs: {
                      mode: _vm.submitMode,
                      "employee-data": _vm.employee_data,
                      "position-data": _vm.data_position
                    },
                    on: {
                      "update-form": _vm.continueUpdate,
                      "close-modal": _vm.closeModalConfirm
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f446e2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f446e2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/assignment/jAssignment.vue
// module id = null
// module chunks = 